<template>
<div class="page-container" ref="pageContainer">
    <div class="a_0Ub" id="app-header">
        <div class="_1IKwD">
            <div class="_39z4S">
                <div class="_3kP_F">
                    <div class="_1q-Gc">
                        <a class="_1sCt-" :href="redirect+'/'">
                            <img :src="img_logo" width="100" alt="bigminer" class="_20oC7">
                        </a>
                    </div>
                </div>
                <div class="_26uU7">
                    <div class="tEljt dropdown dropdown-user" role="navigation"
                        v-bind:class="{'is-active': isMenuDropdownActive}"
                        v-on-clickaway="menuAway">
                        <div class="_2Qi9X HjNLh dropdown-trigger"
                            @click="isMenuDropdownActive = !isMenuDropdownActive">
                            <div class="UWus_">
                                <div class="_2r-m0">
                                    <span class="lEHaK">
                                        <div class="VggX1">
                                            <div class="_34u8O">
                                                <img src="@/assets/197f2c59.svg" class="_2C6NU" alt="" width="16" />
                                                <strong>{{ savedProfile.login }}</strong>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="_3Gd4V dropdown-menu">
                            <div>
                                <ul class="_1mOJw">
                                    <div class="_3uGaJ">
                                        <li class="_2rkZw"><a class="_1Aznq _1ilpw" :href="redirect+'/notifications'">{{ $t('menu-notification') }}</a></li>
                                        <li class="_2rkZw"><a class="_1Aznq _1ilpw" :href="redirect+'/funds'">{{ $t('menu-fund') }}</a></li>
                                        <li class="_2rkZw"><a class="_1Aznq _1ilpw" :href="redirect+'/referrals'">{{ $t('menu-referral') }}</a></li>
                                        <li class="_2rkZw"><a class="_1Aznq _1ilpw" :href="redirect+'/statistics'">{{ $t('menu-stat') }}</a></li>
                                        <!-- <li class="_2rkZw"><a class="_1Aznq _1ilpw" href="/account">{{ $t('menu-account') }}</a></li> -->
                                        <li class="_2rkZw">
                                            <router-link class="_1Aznq _1ilpw" :to="{name: 'Logout'}">{{ $t('menu-signout') }}</router-link>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> <!-- end app-header -->
    <div class="_5MXdL"></div>
    <div class="_3b9iP">
        <div class="_1530I">
            <div class="_1oTUQ">
                <h4 class="_3kxuL"><span>{{ $t('title-account') }}</span></h4>
            </div>
            <div class="_3nkuL kHdPn">
                <div class="kXGVr">
                    <h5 class="_1AwIG"><span>{{ $t('title-profile') }}</span></h5>
                    <div class="tvHgP">
                        <span>{{ $t('tips-login') }}</span>
                    </div>
                </div>
                <div class="_1OyfM">
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('placeholder-login') }}</span></h5>
                        <form class="_1pK6a">
                            <input class="D0pq0 zHzr-" type="text" name="login" autocomplete="off" :placeholder="$t('enter-value')" maxlength="50" v-model="profile.login" />
                            <div v-show="profile.login !== savedProfile.login" class="_4gV91">
                                <span class="_2XQXE" @click="profile.login = savedProfile.login"><span>{{ $t('button-cancel') }}</span></span>
                                <button type="button" class="_1wUGw _2ff4Z" title="" @click="changeProfile('login')"><span>{{ $t('button-save') }}</span></button>
                            </div>
                        </form>
                    </div>
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('full-name') }}</span></h5>
                        <form class="_1pK6a">
                            <input class="D0pq0 zHzr-" type="text" name="name" autocomplete="off" :placeholder="$t('enter-value')" maxlength="50" v-model="profile.name" />
                            <div v-show="this.profile.name !== this.savedProfile.name" class="_4gV91">
                                <span class="_2XQXE" @click="profile.name = savedProfile.name"><span>{{ $t('button-cancel') }}</span></span>
                                <button type="button" class="_1wUGw _2ff4Z" title="" @click="changeProfile('name')"><span>{{ $t('button-save') }}</span></button>
                            </div>
                        </form>
                    </div>
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('placeholder-email') }}</span></h5>
                        <form class="_1pK6a">
                            <input class="D0pq0 zHzr-" type="text" name="email" autocomplete="off" :placeholder="$t('enter-value')" maxlength="50" v-model="profile.email" />
                            <div v-show="this.profile.email !== this.savedProfile.email" class="_4gV91">
                                <span class="_2XQXE" @click="profile.email = savedProfile.email"><span>{{ $t('button-cancel') }}</span></span>
                                <button type="button" class="_1wUGw _2ff4Z" title="" @click="changeProfile('email')"><span>{{ $t('button-save') }}</span></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ValidationObserver v-slot="{ invalid }">
            <div class="_3nkuL kHdPn">
                <div class="kXGVr">
                    <h5 class="_1AwIG"><span>{{ $t('placeholder-password') }}</span></h5>
                    <div class="tvHgP">
                        <span>{{ $t('tips-change-password') }}</span>
                    </div>
                </div>
                <div class="_1OyfM">
                    <ValidationProvider name="current-password" rules="" v-slot="{ errors }">
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('current-password') }}</span></h5>
                        <input :type="pwdType" class="zHzr-" name="old_password" v-model="password.old_password" />
                        <div class="err-msg" v-show="errors[0]">{{ errors[0] }}</div>
                    </div>
                    </ValidationProvider>
                    <ValidationProvider name="new-password" rules="required|min:8|password" v-slot="{ errors }">
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('new-password') }}</span></h5>
                        <input :type="pwdType" class="zHzr-" name="new" v-model="password.new_password" />
                        <div class="err-msg" v-show="errors[0]">{{ errors[0] }}</div>
                        <div class="_2PUz8">
                            <span>{{ $t('tips-password') }}</span>
                        </div>
                    </div>
                    </ValidationProvider>
                    <ValidationProvider name="confirm-new-password" rules="required|confirmed:new-password" v-slot="{ errors }" data-vv-as="password">
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('confirm-new-password') }}</span></h5>
                        <input :type="pwdType" class="zHzr-" name="confirm" v-model="password.confirm_password" />
                        <div class="err-msg" v-show="errors[0]">{{ errors[0] }}</div>
                    </div>
                    </ValidationProvider>
                    <button type="button" :disabled="invalid" class="_3XBGY _1LQ7W" @click="changePassword"><span>{{ $t('button-update-password') }}</span></button>
                    <div title="Show" class="_3MPNh" @click="showPwd">
                        <img src="@/assets/c2f828d1.svg" class="_3M19c" alt="" />
                    </div>
                </div>
            </div>
            </ValidationObserver>
            <div class="_3nkuL kHdPn">
                <div class="kXGVr">
                    <h5 class="_1AwIG"><span>{{ $t('title-bio') }}</span></h5>
                    <div class="tvHgP">
                        <p><span>{{ $t('tips-bio') }}</span></p>
                        <p><span>{{ $t('optional') }}</span></p>
                    </div>
                </div>
                <div class="_1OyfM">
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('Phone') }}</span></h5>
                        <input type="text" class="zHzr-" name="phone" value="" v-model="profile.props.phone"/>
                    </div>
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>Telegram</span></h5>
                        <input type="text" class="zHzr-" name="telegram" value="" v-model="profile.props.telegram" />
                    </div>
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>Skype</span></h5>
                        <input type="text" class="zHzr-" name="skype" value="" v-model="profile.props.skype" />
                    </div>
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('company-info') }}</span></h5>
                        <textarea class="A_Y3c" name="company_info" cols="50" rows="6" v-model="profile.props.company_info"></textarea>
                    </div>
                    <div class="_1wCHM">
                        <h5 class="_2UEfc"><span>{{ $t('timezone') }}</span></h5>
                        <v-select class="dropdown-timezone"
                            :options="filterTimezone()" :reduce="val => val.code"
                            v-model="profile.props.tz">
                        </v-select>
                    </div>
                    <button type="button" class="_3XBGY _1LQ7W" @click="changeProfile('props')">
                        <span>{{ $t('button-update-info') }}</span>
                    </button>
                </div>
            </div>
            <!--
            <div class="_3nkuL">
                <div class="kXGVr"></div>
                <div class="_1OyfM _2AsRQ">
                    <div class="_2RXPO">
                        <button type="button" class="_3XBGY _1LQ7W"><span>Advanced Settings</span></button>
                    </div>
                </div>
            </div>
            <div>
                <div class="_3nkuL">
                    <div class="kXGVr">
                        <h5 class="_1AwIG"><span>Delete account</span></h5>
                        <div class="tvHgP">
                            <span>Removing the account will also delete everything contained in it - farms, workers, flight sheets, wallets etc. If there are active workers in the farms - they will continue mining with the same configs.</span>
                            <br><br>
                            <span>Unspent balance of account and farms will be lost, unpaid referral balance will be lost. Funds withdrawal is not available.</span>
                            <br><br>
                            <strong><span>Removed account cannot be restored!</span></strong>
                        </div>
                    </div>
                    <div class="_1OyfM">
                        <div class="_2RXPO">
                            <button type="button" class="_3XBGY _1qesw"><span>Delete account</span></button>
                        </div>
                    </div>
                </div>
            </div>
            -->
        </div>
    </div>
</div>
</template>
<script>
import img_logo from '@/assets/bigminer-logo.svg';
import { mixin as clickaway } from 'vue-clickaway';
import Timezones from '@/utils/timezones.json';
import Vue from 'vue'
import vSelect from 'vue-select'
import { extend } from 'vee-validate';
import i18n from '@/i18n'

Vue.component('v-select', vSelect)

extend('password', {
    validate: pw => {
        if (/[A-Z]/.test(pw) &&
            /[a-z]/.test(pw) &&
            /[0-9]/.test(pw) &&
            /[!@#$%?^&*()_~+=<>';:`]/.test(pw)) {
            return true;
        } else {
            return i18n.t('tips-password-not-strong');
        }
    }
});
extend('confirmed', {
    validate() {},
    message: i18n.t('new-password-not-match')
});

let redirect = process.env.VUE_APP_REDIRECT_URI || ""
if (redirect && redirect[redirect.length-1] === "/") {
    redirect = redirect.slice(0, redirect.length-1);
}

export default{
	data: () => ({
        savedProfile: {
            email: '',
            name: '',
            login: '',
        },
        profile: {
            email: '',
            name: '',
            login: '',
            props: {
                country_code: '',
                tz: '',
                reg_ip: '',
                reg_date: '',
                phone: '',
                skype: '',
                telegram: '',
                company_info: ''
            }
        },
        password: {
            old_password: '',
            new_password: '',
            confirm_password: ''
        },
        timezoneSelected: {},
        isMenuDropdownActive: false,
        isTimezoneDropdownActive: false,
        redirect,
        pwdType: 'password',
        img_logo,
	}),
    mixins: [clickaway],
    notifications: {
        showMessage: {
            title: '',
            message: '',
            type: 'error'
        }
    },
    created() {
        this.fetchProfile();
    },
	methods: {
		showPwd() {
			if (this.pwdType === 'password') {
				this.pwdType = 'text';
			} else {
				this.pwdType = 'password';
			}
        },
        menuAway() {
            this.isMenuDropdownActive = false;
        },
        timezoneAway() {
            this.isTimezoneDropdownActive = false;
        },
        fetchProfile() {
            this.$axios.get(
                '/users/profile'
            ).then(res => {
                this.profile = res.data;
                if (!this.profile.props) this.profile.props = {};
                this.savedProfile.login = res.data.login;
                this.savedProfile.name = res.data.name;
                this.savedProfile.email = res.data.email;
            }).catch(err => {
                if (err.statusCode === 429) {
                    this.showMessage({ message: this.$t('request-frequent') });
                } else {
                    this.showMessage({ message: this.$t('profile-fail') });
                }
            });
        },
        filterTimezone() {
            let obj = {};
            let ret = [];
            let offset, tz, isInt, absVar, secondsVar;
            Timezones.forEach(item => {
                if (obj[item] === undefined) {
                    obj[item.timezone] = item;
                }
            });
            for (const x in obj) {
                let item = obj[x];
                offset = item.offset;
                tz = item.timezone;
                isInt = (offset + "").indexOf(".") < 0;
                absVar = Math.abs(offset);
                secondsVar = '';
                if (!isInt) {
                    secondsVar = (absVar * 10 - parseInt(absVar) * 10) / 10 * 60;
                }
                ret.push({
                    label: tz +
                        " (UTC" + ((offset > -1) ? "+" : "-") +
                        (Math.abs(offset) <= 9 ? "0" : "") +
                        parseInt(absVar) + ":" + (secondsVar ? ((secondsVar + '').length > 1 ? secondsVar : '0' + secondsVar) : '00') + ')',
                    code: tz,
                });
            }
            return ret;
        },
        changeProfile(type) {
            let params = {};
            let loader = this.$loading.show();
            if (type && type !== 'props') {
                params[type] = this.profile[type];
            } else {
                params.props = this.profile.props;
            }
            this.$axios.post(
                '/users/profile',
                params
            ).then(() => {
                loader.hide();
                this.showMessage({
                    message: this.$t('profile-change-success'),
                    type: 'success',
                });
                if (type && type !== 'props') {
                    this.savedProfile[type] = this.profile[type];
                }
            }).catch(() => {
                loader.hide();
                this.showMessage({ message: this.$t('profile-fail') });
            });
        },
        changePassword() {
            let loader = this.$loading.show();
            this.$axios.post(
                '/auth/password',
                {
                    old: this.password.old_password,
                    password: this.password.new_password,
                },
            ).then(res => {
                loader.hide();
                if (res.data.success) {
                    this.showMessage({
                        message: this.$t('password-change-success'),
                        type: 'success'
                    });
                } else {
                    this.showMessage({ message: this.$t('password-change-fail') });
                }
            }).catch(err => {
                loader.hide();
                if (err.message === 'REGISTRATION.WRONG_PASSWORD') {
                    this.showMessage({ message: this.$t('wrong-password') });
                } else {
                    this.showMessage({ message: this.$t('password-change-fail') });
                }
            });
        },
	}
}
</script>
<style rel="stylesheet/scss" lang="scss">
.a_0Ub {
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    top: 0;
    background: var(--hos-dark-bg);
    color: #d0d4d7;
    -webkit-box-shadow: 0 4px 12px rgba(0,0,0,.25);
    box-shadow: 0 4px 12px rgba(0,0,0,.25)
}
@media screen and (max-width:1200px) {
    .a_0Ub {
        padding-left: 15px;
        padding-right: 15px;
        width: 100vw;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }
}

._1IKwD {
    margin: 0 auto;
    max-width: var(--max-content-width);
    text-align: center;
    padding: 3px 0 2px
}

._39z4S {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 100%
}

._3kP_F {
    position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    text-align: left
}
._1q-Gc {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: justify;
    justify-content: space-between;
    color: var(--hos-white-color);
    height: 35px;
    line-height: 31px
}

._1sCt- {
    -ms-flex: 0 0 90px;
    flex: 0 0 90px;
    color: rgb(204, 204, 204);
    text-decoration: none;
    font-size: 1.5em
}
._20oC7 {
    top: -2px
}
._26uU7 {
    display: -ms-flexbox;
    display: flex
}
.tEljt {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: end;
    justify-content: flex-end
}

._2Qi9X {
    display: inline-block;
    margin-left: 21px;
    font-size: 14px;
    line-height: 30px
}

.VggX1 {
    position: relative;
    font-size: 12px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: end;
    justify-content: flex-end
}
._2C6NU {
    display: none
}
._34u8O {
    line-height: 31px;
    font-size: 14px;
    text-align: right;
    padding-right: 15px;
}
@media screen and (max-width:480px) {
    ._2C6NU {
        position: relative;
        display: block
    }

    ._34u8O strong {
        display: none
    }

    ._34u8O {
        padding-right: 0;
        padding-top: 9px
    }

    ._2Qi9X {
        margin-left: 29px
    }
}

._5MXdL {
    position: relative;
    padding: var(--header-height) 0 5px;
    background-color: var(--hos-extra-dark-bg)
}
._3b9iP {
    padding: 20px 0;
    background-color: var(--hos-dark-bg)
}

._1530I {
    margin: 0 auto;
    padding: 0 15px 40px;
    max-width: var(--max-content-width)
}

._3nkuL {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: justify;
    justify-content: space-between
}

._3nkuL,.kXGVr {
    position: relative
}

.kXGVr {
    -ms-flex: 0 0 36%;
    flex: 0 0 36%;
    padding-right: 30px
}
@media screen and (max-width:992px) {
    ._3nkuL {
        -ms-flex-direction: column;
        flex-direction: column
    }

    ._1OyfM,.kXGVr {
        width: 100%
    }

    .kXGVr {
        padding-right: 0
    }
}
._3MPNh {
    display: inline-block;
    position: relative;
    margin-left: 15px;
    opacity: .6
}

._3MPNh:hover {
    opacity: 1
}

._3MPNh._1VZ7C:before {
    content: "";
    height: 100%;
    width: 2px;
    display: block;
    position: absolute;
    background: #fff;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    left: 7px;
    top: 2px
}
._3M19c {
    cursor: pointer;
    width: 17px;
    height: auto;
    position: relative
}

._1OyfM {
    position: relative;
    -ms-flex: 0 0 56%;
    flex: 0 0 56%;
    padding-top: 2px
}
._1oTUQ {
    font-size: 12px;
    color: var(--hos-white-color);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    line-height: 32px;
    margin-bottom: 0;
    font-weight: 700
}

._3kxuL {
    margin: 0;
    padding: 0;
    font-size: 18px;
    font-weight: 800
}

.kHdPn {
    border-bottom: 1px solid var(--hos-extra-light-bg);
    padding-bottom: 30px;
    margin-bottom: 10px
}

._1M4_O {
    -ms-flex: 0 0 50px;
    flex: 0 0 50px;
    text-align: right;
    padding: 5px 2px
}

._1AwIG {
    color: var(--hos-white-color);
    margin-top: 20px;
    margin-bottom: 20px
}

.tvHgP {
    font-size: 12px;
    color: var(--hos-grey-color);
    line-height: 1.75
}
.A_Y3c,.zHzr- {
    position: relative;
    border: 1px solid var(--hos-xxl-light-bg);
    background: var(--hos-light-bg);
    display: block;
    font-size: 14px;
    padding: 12px 20px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 30px;
    border-radius: 3px;
    color: var(--hos-white-color);
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 18px;
    outline: none;
    -webkit-transition: all .1s ease-out;
    -o-transition: all .1s ease-out;
    transition: all .1s ease-out
}

.zHzr-:focus,.zHzr-:hover {
    border: 1px solid var(--hos-grey-color)
}

.zHzr-:disabled {
    border: 1px solid var(--hos-xxl-light-bg)
}

h5._2UEfc {
    margin-bottom: 2px;
    padding-bottom: 2px
}

._2PUz8,h5._2UEfc {
    font-size: 12px;
    font-weight: 400;
    color: var(--hos-grey-color)
}

._2PUz8 {
    padding: 3px;
    line-height: 1.75
}
._1wCHM {
    position: relative;
    margin-bottom: 24px
}
._1pK6a {
    position:relative
}
.bGhyx .D0pq0 {
    border-color:var(--hos-red-color);
}
.D0pq0{
    padding:12px 20px
}
@media screen and (min-width:769px){
    .D0pq0{
        padding:12px 130px 12px 20px;
    }
}
._3XBGY{position:relative;font-size:13px;line-height:20px;border:1px solid #f1f1f488;background-color:transparent;padding:5px 15px 6px;color:var(--hos-white-color);border-radius:3px;font-weight:700;outline:none!important;-webkit-transition:all .2s ease-out;-o-transition:all .2s ease-out;transition:all .2s ease-out;cursor:pointer}._3XBGY:focus,._3XBGY:hover{-webkit-box-shadow:0 4px 32px rgba(13,14,49,.57);box-shadow:0 4px 32px rgba(13,14,49,.57);color:var(--hos-white-text)}._3XBGY[disabled]{opacity:.5;cursor:not-allowed}._1_k-N{border-color:transparent!important;outline:none!important;font-weight:400!important}._3XBGY+._3XBGY{margin-left:10px}._6aGGO{background-color:var(--hos-light-bg);color:var(--hos-white-color);border:1px solid var(--hos-xxxl-light-bg)}._6aGGO:hover{background-color:var(--blue-xxl-light-bg)}._39noV{background-color:var(--green-color-hl);border:0;color:var(--green-color)}._39noV:hover{background-color:var(--green-color-hl-hover)}.kc5Jc{background-color:var(--orange-color-hl);border:0;color:var(--orange-color)}._1qesw{background-color:var(--red-color-hl)}._1qesw,._2rJE3{border:0;color:var(--red-color)}._2rJE3,._302F_{background-color:transparent}._302F_{padding:5px 8px 6px;cursor:pointer;-webkit-box-shadow:0;box-shadow:0;border:0;opacity:.78}._302F_:focus,._302F_:hover{opacity:1;-webkit-box-shadow:none!important;box-shadow:none!important}._2IXIn{background-color:var(--hos-light-bg);padding:5px 8px 6px;cursor:pointer;-webkit-box-shadow:0;box-shadow:0;border:0}._2IXIn:focus,._2IXIn:hover{background-color:var(--hos-xxl-light-bg);-webkit-box-shadow:none!important;box-shadow:none!important}.WDq1N{background-color:var(--hos-white-color);color:var(--hos-xxl-light-bg);padding:5px 8px 6px;cursor:pointer;-webkit-box-shadow:0;box-shadow:0;border:0}.WDq1N:focus,.WDq1N:hover{color:var(--hos-xxxl-light-bg);background-color:var(--hos-white-text)}._1LQ7W,.WDq1N:focus,.WDq1N:hover{-webkit-box-shadow:none!important;box-shadow:none!important}._1LQ7W{font-weight:600;background-color:var(--hos-xxl-light-bg);color:var(--hos-white-color);border:0}._1LQ7W:hover{background-color:var(--hos-xxxl-light-bg);color:var(--hos-white-text)}._1BweZ{font-weight:600;color:var(--hos-xxl-light-bg);background-color:var(--hos-white-color);border:0;-webkit-box-shadow:none!important;box-shadow:none!important}._1BweZ:active,._1BweZ:focus,._1BweZ:hover{color:var(--hos-xxxl-light-bg);background-color:var(--hos-white-text)}._1BweZ:focus{color:var(--hos-xxxl-light-bg);background-color:var(--hos-white-color)}@media screen and (max-width:768px){._3XBGY{font-size:11px;padding:4px 10px 5px}._3XBGY+._3XBGY{margin-left:7px}}
.css-156aglz-control{
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(40, 44, 52);
    border-color: rgb(56, 62, 74);
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    justify-content: space-between;
    min-height: 42px;
    position: relative;
    transition: all 100ms ease 0s;
    box-sizing: border-box;
    margin-top: 18px;
    font-size: 14px;
    outline: 0px !important;
}
.css-1hwfws3 {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex: 1 1 0%;
    flex-wrap: wrap;
    padding: 2px 8px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}
.css-2pxl9w-singleValue {
    color: rgb(204, 204, 204);
    margin-left: 2px;
    margin-right: 2px;
    max-width: calc(100% - 8px);
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
    opacity: 1;
    transition: opacity 300ms ease 0s;
}
.css-8qcnkh {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    visibility: visible;
    color: rgb(204, 204, 204);
    box-sizing: border-box;
}
.css-1wy0on6 {
    -webkit-box-align: center;
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-shrink: 0;
    box-sizing: border-box;
}
.css-bgvzuu-indicatorSeparator {
    align-self: stretch;
    background-color: rgb(204, 204, 204);
    margin-bottom: 8px;
    margin-top: 8px;
    width: 1px;
    box-sizing: border-box;
}
.css-91tuoj-indicatorContainer {
    color: rgb(204, 204, 204);
    display: flex;
    padding: 8px;
    transition: color 150ms ease 0s;
    box-sizing: border-box;
}
.css-19bqh2r {
    display: inline-block;
    fill: currentcolor;
    line-height: 1;
    stroke: currentcolor;
    stroke-width: 0;
}
._2AsRQ, ._2RXPO {
    position: relative;
    margin-top: 18px;
}
._1pK6a,._4gV91 {
    position:relative;
}
._4gV91 {
    padding:5px 1px 5px 5px;
    text-align:right;
    font-size:12px;
}
@media screen and (min-width:769px) {
    ._4gV91 {
        position:absolute;
        bottom:6px;
        right:14px;
        padding:0;
    }
}
._2XQXE {
    font-size:12px;
    color:var(--hos-white-color);
    margin-right:12px;
    -webkit-transition:color .3s ease-out;
    -o-transition:color .3s ease-out;
    transition:color .3s ease-out;
    cursor:pointer;
    &:hover {
        color:#e8e0d4;
    }
}
._1wUGw {
    position: relative;
    font-size: 13px;
    line-height: 20px;
    border: 1px solid #f1f1f488;
    background-color: transparent;
    padding: 5px 15px 6px;
    color: var(--hos-white-color);
    border-radius: 3px;
    font-weight: 700;
    outline: none!important;
    -webkit-transition: all .2s ease-out;
    -o-transition: all .2s ease-out;
    transition: all .2s ease-out;
    cursor: pointer;
}
._2ff4Z {
    font-weight: 600;
    color: var(--hos-xxl-light-bg);
    background-color: var(--hos-white-color);
    border: 0;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}
._1wUGw:focus, ._1wUGw:hover {
    -webkit-box-shadow: 0 4px 32px rgba(13,14,49,.57);
    box-shadow: 0 4px 32px rgba(13,14,49,.57);
    color: var(--hos-white-text);
}
._2ff4Z:active, ._2ff4Z:hover {
    color: var(--hos-xxxl-light-bg);
    background-color: var(--hos-white-text);
}
.dropdown-user {
    position: relative;
    .dropdown-trigger {
        cursor: pointer;
    }
    .dropdown-menu {
        position: absolute;
        top: 32px;
        right: 0;
        z-index: 1;
        display: none;
    }
}
.dropdown-user.is-active .dropdown-menu {
    display: block;
}
._3Gd4V {
    z-index: 1002;
    -webkit-animation: _2ZMiU .5s;
    animation: _2ZMiU .5s;
    max-width: 90vw;
    max-height: 90vh;
    margin: 5px 0
}
@media screen and (min-width:769px) {
    ._3Gd4V {
        max-width: 640px;
        max-height: 60vh
    }
}
._1mOJw {
    list-style: none;
    margin: 0;
    z-index: 10;
    padding: 5px 0 0;
    overflow: auto;
    max-height: calc(100vh - 75px);
}
._3uGaJ {
    border-radius: 3px;
    -webkit-box-shadow: 0 4px 43px rgba(5,3,3,.36),0 1px 2px rgba(0,0,0,.05),0 0 0 1px rgba(0,7,10,.1);
    box-shadow: 0 4px 43px rgba(5,3,3,.36),0 1px 2px rgba(0,0,0,.05),0 0 0 1px rgba(0,7,10,.1)
}
._2rkZw {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px;
    text-decoration: none;
    background: #15171b;
    color: var(--hos-white-color);
    border-bottom: 1px solid var(--hos-extra-dark-bg);
    line-height: 40px;
    -webkit-transition: all .2s ease-out;
    -o-transition: all .2s ease-out;
    transition: all .2s ease-out;
    white-space: nowrap;
    min-width: 90px;
    font-weight: 400;
    cursor: pointer
}

._2rkZw:first-child {
    border-radius: 3px 3px 0 0
}

._2rkZw:last-child {
    border-radius: 0 0 3px 3px
}
._2rkZw:hover ._1Aznq,._2rkZw:hover ._1Aznq>._2lgWd {
    color: var(--hos-link-color)
}
._2rkZw:hover ._1aNMJ img {
    opacity: 1
}
._1Aznq {
    padding: 0 25px;
    text-decoration: none;
    color: var(--hos-white-color);
    display: block;
    width: 100%
}
._1ilpw {
    text-transform: capitalize
}

// vue-select
$vs-colors: (
    lightest: #ccc,
    light: #ccc,
    dark: #ccc,
    darkest: rgba(60, 60, 60, 0.2),
);
$vs-selected-bg: #282c34;
$vs-border-color: #383e4a;
$vs-dropdown-bg: #1e2127;
$vs-state-active-bg: #262930;
$vs-state-active-color: #aaa;
$vs-dropdown-max-height: 200px !default;

@import "vue-select/src/scss/vue-select.scss";

.dropdown-timezone {
    font-size: 14px;
    color: #cccccc;
    .vs__search::placeholder,
    .vs__dropdown-toggle,
    .vs__search,
    .vs__dropdown-menu {
        color: #cfcfcf;
    }
    .vs__dropdown-option {
        padding: 10px 20px;
        color: #eee;
    }
    .vs__dropdown-option--highlight {
        color: #aaa;
    }
    .vs__dropdown-toggle {
        background: #282c34;
    }
    .vs__selected,
    .vs__search {
        margin-left: 0;
        padding-left: 17px;
        line-height: 2;
    }
    .vs__clear {
        display: none;
    }
    .vs__actions {
        padding-right: 12px;
        &:before {
            content: "";
            margin-right: 10px;
            display: inline-block;
            width: 1px;
            height: 24px;
            background: #cfcfcf;
        }
    }
}

</style>
